import {
  STOCK_AUDIT_CREATE,
  STOCK_AUDIT_UPLOAD_CSV,
  STOCK_AUDIT_EDIT,
  STOCK_AUDIT_TABLE,
  STOCK_AUDIT_VIEW,
  STOCK_DETAILS_BATCH_DROP_DOWN,
  STOCK_DETAILS_BATCH_UPDATE,
  STOCK_DETAILS_BATCH_VIEW,
  STOCK_DETAILS_ITEMS_FETCH,
  STOCK_DETAILS_ITEM_VIEW,
  STOCK_DETAILS_WAREHOUSE_LOCATION,
  STOCK_AUDIT_LOAD_FILTERS,
  STOCK_AUDIT_DELETE,
} from "../types";

export const stockDetailsItemsFetchAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_DETAILS_ITEMS_FETCH,
    data,
    onSuccess,
    onError,
  };
};
export const stockDetailsItemViewAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_DETAILS_ITEM_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const stockDetailsWarehouseLocationAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: STOCK_DETAILS_WAREHOUSE_LOCATION,
    data,
    onSuccess,
    onError,
  };
};
export const stockDetailsBatchUpdateAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_DETAILS_BATCH_UPDATE,
    data,
    onSuccess,
    onError,
  };
};
export const stockDetailsBatchDropDownAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_DETAILS_BATCH_DROP_DOWN,
    data,
    onSuccess,
    onError,
  };
};
export const stockDetailsBatchViewAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_DETAILS_BATCH_VIEW,
    data,
    onSuccess,
    onError,
  };
};

///  stock AUDIT

export const stockAuditCreateAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const stockAuditTableAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const stockAuditViewAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const stockAuditEditAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const stockAuditUploadCsvAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_UPLOAD_CSV,
    data,
    onSuccess,
    onError,
  };
};
export const stockAuditLoadFiltersAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_LOAD_FILTERS,
    data,
    onSuccess,
    onError,
  };
};
// TODO: placeholder delete action — swap for the real audit delete/void action when the backend endpoint exists
export const stockAuditDeleteAction = (data, onSuccess, onError) => {
  return {
    type: STOCK_AUDIT_DELETE,
    data,
    onSuccess,
    onError,
  };
};
